module.exports = __webpack_public_path__ + "img/blue_017.18b2fc3f.png";